/**
 * TabTrips IVR proxy — no IVR vendor token in the browser.
 * All calls go through ivr.php with the admin JWT.
 */
export const IVR_PROXY_BASE =
  'https://api.tabtrips.com/olivrweb/hotelapi/ivr.php';

/** Fallback DID if meta has none yet */
export const IVR_DEFAULT_DID = '+911140001519';

const PREFS_KEY = 'ivrCallPrefs';

export const getIvrPrefs = () => {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (raw) return JSON.parse(raw);
  } catch (_) {
    /* ignore */
  }
  return { did: IVR_DEFAULT_DID, ext_no: '' };
};

export const setIvrPrefs = (prefs) => {
  const next = {
    did: prefs?.did || IVR_DEFAULT_DID,
    ext_no: prefs?.ext_no ? String(prefs.ext_no) : '',
  };
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify(next));
  } catch (_) {
    /* ignore */
  }
  return next;
};

/** Normalize phone for display / dial payloads (10-digit preferred). */
export const normalizeIvrPhone = (raw) => {
  if (raw == null) return '';
  let s = String(raw).trim();
  if (!s || s === '–' || s === '-') return '';
  s = s.replace(/[^\d+]/g, '');
  if (s.startsWith('+91')) s = s.slice(3);
  else if (s.startsWith('91') && s.length >= 12) s = s.slice(2);
  s = s.replace(/\D/g, '');
  // strip leading zeros for match length, keep 10 digits when possible
  while (s.length > 10 && s.startsWith('0')) s = s.slice(1);
  if (s.length === 10) return s;
  if (s.length === 11 && s.startsWith('0')) return s.slice(1);
  return s;
};
